import { CurrencyDollarSimple } from '@phosphor-icons/react';
import { formatCurrency } from '../../../shared/utils/general.util';

const AnnualPreviewInvoiceItem = ({
	label,
	firstValue,
	index,
}: {
	label: string;
	firstValue: {
		label: string;
		value: string | number;
	};
	index: number;
}) => {
	return (
		<div
			style={{
				animation: 'fadeInScale 0.150s ease forwards',
				animationDelay: `${index * 60}ms`,
				opacity: 0,
			}}
			className='bg-white border border-h-neutral-90 rounded-lg p-2 text-xs md:text-base flex flex-col gap-1'
		>
			<p className='flex items-center gap-1'>
				<CurrencyDollarSimple
					size={16}
					weight='bold'
					className='text-h-primary'
				/>{' '}
				{label}
			</p>
			<hr className='my-1' />
			<div className='flex'>
				<p>
					<span className='font-light text-h-medium'>{firstValue.label}:</span>{' '}
					<span className='text-base font-medium'>
						{formatCurrency(Number(firstValue.value))}
					</span>
				</p>
			</div>
		</div>
	);
};

export default AnnualPreviewInvoiceItem;
